import React, { memo } from 'react';
import { makeStyles } from '~/UIKit/Style';
import { CHARCOAL_GREY } from '~/Constants/Colors.constants';

interface EventImageProps {
  imagePath: string;
}

const useStyles = (eventImage: string) =>
  makeStyles({
    root: {
      left: 0,
      top: 0,
      zIndex: 0,
      background: `linear-gradient(180deg, ${CHARCOAL_GREY} 0.08%, rgba(238,238,238,0) 100%), url(${eventImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      width: '100%',
      height: '100%',
      position: 'absolute',
    },
  });

export const EventImage = memo(({ imagePath }: EventImageProps) => {
  const { classes } = useStyles(imagePath)();
  return <div className={classes.root} />;
});
